import { create } from 'zustand';
import { i18n, SUPPORTED_LANGUAGES, type Language } from '@tarifdata/i18n';

export type ThemeMode = 'system' | 'light' | 'dark';

function initTmaLanguage(): Language {
  const stored = localStorage.getItem('tma-language') as Language | null;
  if (stored && SUPPORTED_LANGUAGES.some((l) => l.code === stored)) return stored;
  const tgLang = window?.Telegram?.WebApp?.initDataUnsafe?.user?.language_code;
  if (tgLang && SUPPORTED_LANGUAGES.some((l) => l.code === tgLang)) return tgLang as Language;
  return 'ru';
}

function initTheme(): ThemeMode {
  const stored = localStorage.getItem('tma-theme');
  return stored === 'light' || stored === 'dark' ? stored : 'system';
}

function systemDark(): boolean {
  const telegram = window.Telegram?.WebApp?.colorScheme;
  if (telegram) return telegram === 'dark';
  return window.matchMedia?.('(prefers-color-scheme: dark)').matches ?? false;
}

interface SettingsState {
  language: Language;
  theme: ThemeMode;
  systemDark: boolean;
  setLanguage: (lang: Language) => void;
  setTheme: (theme: ThemeMode) => void;
  setSystemDark: (dark: boolean) => void;
}

export const useSettingsStore = create<SettingsState>((set) => ({
  language: initTmaLanguage(),
  theme: initTheme(),
  systemDark: systemDark(),
  setLanguage: (lang) => {
    localStorage.setItem('tma-language', lang);
    i18n.changeLanguage(lang);
    set({ language: lang });
  },
  setTheme: (theme) => {
    localStorage.setItem('tma-theme', theme);
    set({ theme });
  },
  setSystemDark: (dark) => set({ systemDark: dark }),
}));
